<div class="cibil-footer">
    <p class="note" *ngIf="isNote">Note: The repayment history is from last 36 months</p>
    <div class="icon-box">
        <img src="assets/svg/icons/cibil-logo.svg" class="icon" alt="Footer icon" />
    </div>
    <p class="footer-text">AUREUS FINVEST PRIVATE LIMITED</p>
</div>
